import { roomNameKey } from '../../../api/src/modules/v3/room-name-key';
import type { OdaSecenegi } from './tipler';
export const ODA_SAYFA_BOYUTU = 5;
export interface FizikselOda { anahtar: string; ad: string; secenekler: OdaSecenegi[] }
export function odalariGrupla(secenekler: readonly OdaSecenegi[]): FizikselOda[] {
  const groups = new Map<string, FizikselOda>();
  for (const secenek of secenekler) {
    const name = roomNameKey(secenek.odaTipi);
    // Missing or conflicting physical details cannot prove that two offers describe one room.
    const key = name ? JSON.stringify([name, secenek.alanM2, secenek.yatakDuzeni?.toLowerCase() ?? null]) : `unknown:${secenek.secenekNo}`;
    const group = groups.get(key);
    if (group) group.secenekler.push(secenek);
    else groups.set(key, { anahtar: key, ad: secenek.odaTipi, secenekler: [secenek] });
  }
  return [...groups.values()];
}
export function seciliOdaSayfasi(odalar: readonly FizikselOda[], secenekNo: string | null): number {
  return Math.floor(Math.max(0, odalar.findIndex(oda => oda.secenekler.some(s => s.secenekNo === secenekNo))) / ODA_SAYFA_BOYUTU);
}
